module.exports = __webpack_public_path__ + "static/media/icon-bid-free.badc2464.png";